import clsx from "clsx"
import React, { CSSProperties, ReactNode } from "react"

import styles from "./index.module.sass"

export interface RowProps {
  highlightable?: boolean
  className?: string
  children?: ReactNode
  style?: CSSProperties
  v?: "body" | "header"
}

export const Row = React.forwardRef<HTMLDivElement, RowProps>(
  (
    { className, highlightable = false, children, style, v: variant = "body" },
    ref
  ) => (
    <div
      ref={ref}
      className={clsx(
        styles.row,
        { [styles.highlightable]: highlightable },
        styles[`variant-${variant}`],
        className
      )}
      style={style}
    >
      {children}
    </div>
  )
)

export default Row
